/**
 * @format
 * @Description: job实例状态机
 * @Autho: 方证
 * @Date: 2019/12/10
 */

import { action, observable, useStrict } from 'mobx';
import Utils from 'utils';
import { get, map } from 'lodash';

const CDN_BASE = 'assets';
useStrict(true);
class JobSampleManageMod {
  @observable
  taskId = 0;

  @observable
  editInfo = {};

  @observable
  visible = false;

  @action
  updateStore(payload) {
    for (let i in payload) {
      this[i] = payload[i];
    }
  }
  onClose = () => {
    this.updateStore({ visible: false });
  };
  getJobSampleListBeforeRequest = data => {
    const { id } = data;
    return {
      pageSize: data.pageSize,
      pageNum: data.pageNum,
      filter: {
        id,
        startTime:data.updateTime && data.updateTime[0].format('YYYY-MM-DD HH:mm:ss'),
        endTime:data.updateTime && data.updateTime[1].format('YYYY-MM-DD HH:mm:ss')
      }
    };
  };
  getJobSampleListAfterRequest = data => {
    map(data.list, item => {
      item.updateTime = item.status == 'RUNNING' ? '' : item.updateTime;
    });
    return data;
  };
  getJobSampleZoneListBeforeRequest = data => {
    return {
      pageSize: data.pageSize,
      pageNum: data.pageNum,
      filter: {
        taskId: this.taskId,
        taskInstId: this.editInfo.id
      }
    };
  };
  getJobSampleZoneListAfterRequest = data => {
    map(data.list, item => {
      item.updateTime = item.status == 'RUNNING' ? '' : item.updateTime;
    });
    return data;
  };
}

// ES6单例写法
export default new JobSampleManageMod();



// WEBPACK FOOTER //
// ./src/pages/DispatchCenter/JobSampleManage/JobSampleManageMod.js